var _defs, _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _circle, _path8, _path9, _rect3, _rect4, _circle2, _circle3, _path10, _rect5, _rect6, _circle4, _rect7, _circle5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _polygon, _polygon2, _path25, _path26, _path27, _path28, _polygon3, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _circle6, _circle7, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResponsiveness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "0315a8ac-3017-4957-93c4-92e478eebb20",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1036,
    height: 612,
    viewBox: "0 0 1036 612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "deacd444-d5db-4c24-9492-02e57292be3c",
    x1: 675.05,
    y1: 606.02,
    x2: 675.05,
    y2: 240.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a1de9c2c-a914-4f57-a703-6b671b828453",
    x1: 473.94,
    y1: 635.65,
    x2: 473.94,
    y2: 301.65,
    xlinkHref: "#deacd444-d5db-4c24-9492-02e57292be3c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "33ead0d0-8f65-4117-bca2-44ecb419ecb0",
    x1: 363.44,
    y1: 662.65,
    x2: 363.44,
    y2: 401.65,
    xlinkHref: "#deacd444-d5db-4c24-9492-02e57292be3c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9a5964b5-9011-4675-8f60-8033350848c0",
    x1: 849.68,
    y1: 703.66,
    x2: 849.68,
    y2: 385.5,
    xlinkHref: "#deacd444-d5db-4c24-9492-02e57292be3c"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "web_devices") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.4,144.07c-8.06-.23-16.32,0-23.88,2.32-20.57,6.32-30.32,27-27.15,44.87s16.21,33.44,29.74,47.67,28.19,28.3,35.61,45.31c3.7,8.49,5.43,18,1.67,26.48-5.8,13.07-23.29,20.37-40.08,21.89s-33.65-1.44-50.5-2.43c-7.07-.41-14.34-.46-21,1.45-7.31,2.08-13.4,6.33-19,10.76-21.85,17.38-39.34,41.09-36.51,66,3.2,28.23,31.74,50.54,63,62.51,10.35,4,21.3,7.18,30.41,12.84,24,14.93,29.39,42.93,27,67.64s-10.53,49.45-6,73.94c5.33,28.49,28.92,54.23,60.74,66.25,28.35,10.71,63.83,10,89-5.11,12.27-7.38,21.55-17.63,29.62-28.23a227.74,227.74,0,0,0,29.45-51c3.51-8.49,6.81-17.62,15-23.52,5-3.63,11.48-5.66,17.89-7.24,19.32-4.76,39.67-6.06,59.17-10.3S536.7,554,547.3,539.9c15-20,8-45.62,8.07-69.14.12-53.66,39.11-101.69,53.5-154,4.7-17.09,6.45-36-4.05-51.25-7.13-10.35-19.16-17.82-31.8-23.59-27.81-12.69-59.42-18.34-90.51-23.84-43.21-7.64-95.68-8.63-129.17-33.35C321.2,161,277.23,144.07,233.4,144.07Z",
    transform: "translate(-82 -144)",
    fill: "#ff8533",
    opacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 571,
    cy: 487.48,
    rx: 465,
    ry: 124.52,
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.18,330.86s-35.83,35.83-15.6,89S988.9,561.45,988.9,561.45s.59-.09,1.68-.28c73.59-13,110.16-97.16,69.24-159.69C1044.61,378.24,1032.12,351,1039.18,330.86Z",
    transform: "translate(-82 -144)",
    fill: "#ff8533"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.18,330.86s-20.23,43.92,0,79.75S1042.65,547,988.9,561.45",
    transform: "translate(-82 -144)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1103,475.79s-40.89-6.51-44.61,30.13-78.62,41.72-78.62,41.72l1.4.93c61.84,40.59,121,25.86,112-28C1089.9,500.49,1090.17,480.36,1103,475.79Z",
    transform: "translate(-82 -144)",
    fill: "#ff8533"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1103,475.79s-40.89-6.51-44.61,30.13-78.62,41.72-78.62,41.72l1.4.93c61.84,40.59,121,25.86,112-28C1089.9,500.49,1090.17,480.36,1103,475.79Z",
    transform: "translate(-82 -144)",
    fill: "#f5f5f5",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1103,475.79s-31.74,7-29.13,35.82-47.13,63.45-94.1,36",
    transform: "translate(-82 -144)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.37,563.92H944.13a21.42,21.42,0,0,0,2.24-9.57V261.79a21.51,21.51,0,0,0-21.51-21.51H427.52A21.51,21.51,0,0,0,406,261.79V554.36a21.42,21.42,0,0,0,2.24,9.57H341.73a5.69,5.69,0,0,0-5.69,5.69v4.59A31.82,31.82,0,0,0,367.86,606H982.24a31.82,31.82,0,0,0,31.82-31.82v-4.59A5.69,5.69,0,0,0,1008.37,563.92Zm-395.89,18.2L607,575.87H743.72l-6.1,6.26Z",
    transform: "translate(-82 -144)",
    fill: "url(#deacd444-d5db-4c24-9492-02e57292be3c)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 330.11,
    y: 100.42,
    width: 528.12,
    height: 327.99,
    rx: 23.26,
    ry: 23.26,
    fill: "#535461"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 341.22,
    y: 148.23,
    width: 504.77,
    height: 267.95,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 593.61,
    cy: 124.88,
    r: 4.45,
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M753.55,560.73,736.2,578.52H613.9l-15.67-17.79H349.29a5.56,5.56,0,0,0-5.56,5.56v4.48a31.1,31.1,0,0,0,31.1,31.1H975.28a31.1,31.1,0,0,0,31.1-31.1v-4.48a5.56,5.56,0,0,0-5.56-5.56Z",
    transform: "translate(-82 -144)",
    fill: "#535461"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M580.41,301.65H367.48a19.51,19.51,0,0,0-19.53,19.48v295a19.51,19.51,0,0,0,19.53,19.48H580.41a19.51,19.51,0,0,0,19.53-19.48v-295A19.51,19.51,0,0,0,580.41,301.65Z",
    transform: "translate(-82 -144)",
    fill: "url(#a1de9c2c-a914-4f57-a703-6b671b828453)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 268.94,
    y: 161.65,
    width: 246,
    height: 327,
    rx: 20,
    ry: 20,
    fill: "#535461"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 281.44,
    y: 192.58,
    width: 221,
    height: 265.14,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.94,
    cy: 176.65,
    r: 3,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.94,
    cy: 472.65,
    r: 9,
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M418.11,401.65H308.78a10.81,10.81,0,0,0-10.83,10.79V651.86a10.81,10.81,0,0,0,10.83,10.79H418.11a10.81,10.81,0,0,0,10.83-10.79V412.44A10.81,10.81,0,0,0,418.11,401.65Z",
    transform: "translate(-82 -144)",
    fill: "url(#33ead0d0-8f65-4117-bca2-44ecb419ecb0)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 216.94,
    y: 259.65,
    width: 129,
    height: 258,
    rx: 11,
    ry: 11,
    fill: "#535461"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 226.44,
    y: 283.65,
    width: 110,
    height: 210,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 268.44,
    cy: 271.65,
    r: 1,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 273.44,
    y: 270.65,
    width: 22,
    height: 2,
    rx: 1,
    ry: 1,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 280.94,
    cy: 503.65,
    r: 7,
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M285.73,680.25s-13.26-45,2.49-78.14A71.09,71.09,0,0,0,294,557.5a119.57,119.57,0,0,0-6.31-20.93",
    transform: "translate(-82 -144)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M297.45,515.63c0,5.52-10,21.51-10,21.51s-10-16-10-21.51a10,10,0,0,1,20,0Z",
    transform: "translate(-82 -144)",
    fill: "#ff8533"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M314,546.19c-3,4.63-20.08,12.63-20.08,12.63s.31-18.86,3.31-23.49A10,10,0,1,1,314,546.19Z",
    transform: "translate(-82 -144)",
    fill: "#ff8533"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M313.24,598.4c-4.93,2.48-23.71.77-23.71.77s9.79-16.12,14.71-18.6a10,10,0,0,1,9,17.84Z",
    transform: "translate(-82 -144)",
    fill: "#ff8533"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M303.8,637.79c-4.44,3.28-23.24,4.76-23.24,4.76s6.92-17.54,11.36-20.82a10,10,0,0,1,11.88,16.06Z",
    transform: "translate(-82 -144)",
    fill: "#ff8533"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M272.91,559.89c4,3.84,22.39,7.83,22.39,7.83s-4.51-18.31-8.47-22.15a10,10,0,1,0-13.92,14.33Z",
    transform: "translate(-82 -144)",
    fill: "#ff8533"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M262.45,606.09c4.93,2.48,23.71.77,23.71.77s-9.79-16.12-14.71-18.6a10,10,0,1,0-9,17.84Z",
    transform: "translate(-82 -144)",
    fill: "#ff8533"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M258.45,652.39c4.44,3.28,23.24,4.76,23.24,4.76s-6.92-17.54-11.36-20.82a10,10,0,0,0-11.88,16.06Z",
    transform: "translate(-82 -144)",
    fill: "#ff8533"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1077,537.1c-11.07-13.43-24.48-28.86-22.6-46.73,1.52-14.47-2.12-27.85-1.4-42.37,1-20.63-3.14-36.78-18-50-8.68-7.73-23.19-13.8-27.51-12.25-8.56,3.06-17.9,1.89-26.71,4-6.69,1.56-11.14,4-13.9,7-5.55,5-5.64,12-3.11,19.45A32.85,32.85,0,0,0,980,462.28c-6.17,2.58-11.5,8.52-13.58,20.58a140.68,140.68,0,0,1-6.53,24.31,39.51,39.51,0,0,1-4,1.61c.3.12.61.2.91.31-.65.25-1.29.5-2,.72a21.21,21.21,0,0,0,3.65,1.06c-8,20.21-18,32.73-18,32.73s-18.65,4.12-25.9-3.09c0,0,1.18,1.38,2.78,3.45-7.09-2.94-18.73-7.74-28.68-11.69-7.22-2.87-9.07,0-9,4a13.32,13.32,0,0,0-5,1.68,48.67,48.67,0,0,0-6.69-3.6c-4.14-1-17.61-8.24-31.08,16.47-7.84,14.37-27.94,40.6-43.39,60-30.05,13.82-69.17,31.32-83.71,35.72h-9.32c-1.22-2-2.07-3.26-2.07-3.26l-.72.48-.31-.48s-18.3,12.67-36.88,12.77a35,35,0,0,1-7.84-1c-8.54-2.15-14.56-3.11-18.86-3-5.09-.09-8,1.12-9.76,3.4h0a8.94,8.94,0,0,0-.65.94v0a11.05,11.05,0,0,0-.54,1l0,0c-.16.36-.32.74-.46,1.13a2.32,2.32,0,0,0,.58,1.95,10.42,10.42,0,0,0,.81,1l.52.56c2.34,2.42,6.6,5.63,11.9,9.21,1.53,1,3.15,2.1,4.84,3.19l3.21,2,2.87,1.79,1.15.71,1.28.78,2.29,1.39,1.36.82,2.57,1.53,2.08,1.23c5.44,3.21,10.86,6.32,15.75,9.08L677,695.8l.33.18,2.2,1.23,3.8,2.11,2.61,1.44,1.22.67,1.31.72.26.14,2.28,1.24a3.3,3.3,0,0,0,2.66-.72c.66-2.8,2.27-8.8,4-9.26S706.89,680,709,671.24h20.22a89.13,89.13,0,0,0,11.84-1.82c-5.22,3.72-10.39,6.06-14.41,5.06-8.5-2.11-16.55,3.07-17.36,8.18,0,.11-.07.21-.1.32s-.05.21-.07.31-.06.25-.08.38,0,.21,0,.32,0,.25,0,.38,0,.21,0,.31,0,.26,0,.39,0,.2,0,.3.06.27.1.41,0,.18.07.26a5,5,0,0,0,.22.53l.05.13a5.38,5.38,0,0,0,.38.63l.16.21c.1.14.21.28.33.41l.23.23c.12.12.25.24.38.36l.28.23.45.33.33.22.54.32.36.19.68.32.34.15c.36.15.74.29,1.15.42.65.21,1.42.43,2.29.65l.87.21,1.27.29.67.15q1.3.28,2.76.56l1.35.25,1.1.2,2.53.44c1.58.27,3.23.54,5,.8l4.36.66,5.68.81,1.26.17,2,.28,2.93.39,2,.26h0l5.19.66,1.62.2,3.27.4c4.3.52,8.46,1,12.29,1.43l4.43.5,2.24.25,1,.1,2.68.29,1.49.16,1.84.19,2.59.27.28,0,1.66.17h0a1.51,1.51,0,0,0,1.67-1.47v0h0c0-.05,0-.11,0-.17a1.46,1.46,0,0,0,.24-.78,34,34,0,0,1,.93-7.32c.11-.41.24-.83.38-1.25l.16-.48c.18-.51.36-1,.57-1.55a11.12,11.12,0,0,0,.39-1.14c0-.12.07-.24.11-.37s.1-.41.14-.62c2.08-7.11-.43-20.37-1.15-25.58a27.77,27.77,0,0,0-1.14-4.9,2,2,0,0,0,.39,0,11.79,11.79,0,0,0,3-1.63c15.28-5.45,28.16-11.68,32.23-17.92a27.91,27.91,0,0,1,19.68,2.06c7.91,3.93,67.75,23.46,95.61,32.48,5,4.31,8.92,6.83,11.09,6.64,0,0,35.47,5.74,49.73-5.46,1.27.88,2.07,1.35,2.07,1.35s20.72-10.29,23.83-23.68c1-4.34,1.91-10.74,2.84-17.82a25.91,25.91,0,0,0,7.52-18.21c.65-22.48,9.36-48.16,15.82-71,7.84.62,10.87-.86,18.06-4.41l-.32-.41C1076.1,537.52,1076.55,537.32,1077,537.1ZM958.21,570.77l-4-1.33a33,33,0,0,0,3.45-5.74Zm-22.29,9.46,24,14.4.21,2.93a21,21,0,0,0,.2,6.7C949.75,594.86,937.37,583.45,935.91,580.22Zm-9.8-21c-2.62-1.08-4.79-2.06-6.28-2.87,2,.14,3.9.26,5.56.35A12.44,12.44,0,0,1,926.12,559.23Zm-64.28,23.47s4.14-9.26,13.47,6.18c1.45,2.4,4.12,6.22,7.65,10.95L855.8,596.2C859,591.24,861.15,586.63,861.84,582.71Z",
    transform: "translate(-82 -144)",
    fill: "url(#9a5964b5-9011-4675-8f60-8033350848c0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M921.5,545.5s-19-8-34-14-6,14-6,14,25,7,25,8,21,2,21,2Z",
    transform: "translate(-82 -144)",
    fill: "#f7c4a7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M921.5,545.5s-19-8-34-14-6,14-6,14,25,7,25,8,21,2,21,2Z",
    transform: "translate(-82 -144)",
    opacity: 0.05
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.5,466.5s-34-18-40,17-25,59-25,59-18,4-25-3c0,0,17,20,9,22,0,0,18,13,26,9s14-31,17-38S978.5,464.5,1002.5,466.5Z",
    transform: "translate(-82 -144)",
    fill: "#ae8eb4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.5,466.5s-34-18-40,17-25,59-25,59-18,4-25-3c0,0,17,20,9,22,0,0,18,13,26,9s14-31,17-38S978.5,464.5,1002.5,466.5Z",
    transform: "translate(-82 -144)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M983.5,454.5s21,24,22,44,24-21,26-22-20-35-22-46S983.5,454.5,983.5,454.5Z",
    transform: "translate(-82 -144)",
    fill: "#f7c4a7"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "916 320.75 902.75 332.75 909 358 926 342 924 326 916 320.75",
    fill: "#f7c4a7"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "639.5 498.5 616.5 498.5 625.5 520.5 647.5 514.5 639.5 498.5",
    fill: "#f7c4a7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M703.82,639.33S680,655.92,659.65,650.76s-25.88-3.23-28.25,3.43c-2.19,6.13,56.84,38.55,66.25,43.67a1.08,1.08,0,0,0,1.57-.7c.64-2.72,2.19-8.55,3.85-9,2.16-.58,12-19,11.46-26.24S703.82,639.33,703.82,639.33Z",
    transform: "translate(-82 -144)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M702.82,639.33S679,655.92,658.65,650.76s-25.88-3.23-28.25,3.43c-2.19,6.13,56.84,38.55,66.25,43.67a1.08,1.08,0,0,0,1.57-.7c.64-2.72,2.19-8.55,3.85-9,2.16-.58,12-19,11.46-26.24S702.82,639.33,702.82,639.33Z",
    transform: "translate(-82 -144)",
    fill: "#f3b5b7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M899.5,599.5l-67-9s-109,52-122,53l3,23h20c8,0,86-17,97-34a26.78,26.78,0,0,1,19,2c10,5,106,36,106,36Z",
    transform: "translate(-82 -144)",
    fill: "#ae8eb4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M899.5,599.5l-67-9s-109,52-122,53l3,23h20c8,0,86-17,97-34a26.78,26.78,0,0,1,19,2c10,5,106,36,106,36Z",
    transform: "translate(-82 -144)",
    opacity: 0.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "698.5 486.5 687.5 500.5 698.5 506.5 714.5 494.5 698.5 486.5",
    fill: "#f7c4a7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M971.5,614.5s-36-30.82-38.49-36.41S871.5,534.5,867.5,533.5s-17-8-30,16-61,82-61,82,15,21,20,20,61-48,65-71c0,0,4-9,13,6s67,87,78,86c0,0,43,7,52-10S971.5,614.5,971.5,614.5Z",
    transform: "translate(-82 -144)",
    fill: "#ae8eb4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M992,468s-12.5,5.5-13.5,28.5-23,62-23,62l2,46s24,24,26,39,19,25,19,25,20-10,23-23,5-45,10-57,2-87,2-87l-15-26-8-9-21,24S982,475,992,468Z",
    transform: "translate(-82 -144)",
    fill: "#dddbe2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M962.5,589.5s-3-36,6-44l18-51S993,470,992,468s-23.5,19.5-23.5,19.5l-15,53,4,56Z",
    transform: "translate(-82 -144)",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M961.5,589.5s-3-36,6-44l18-51s7-25,6-27-24,20-24,20l-15,53,4,56Z",
    transform: "translate(-82 -144)",
    fill: "#ae8eb4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M968.5,573.5s-50-16-53-20-35-30-46-12,41,23,41,23l53,32Z",
    transform: "translate(-82 -144)",
    fill: "#f7c4a7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M782.67,644.41l-14.8-2.66S743.63,672.8,731,669.65s-24.25,10.44-10.91,14.8c12.05,3.94,64.09,9.45,74,10.47a1.46,1.46,0,0,0,1.61-1.42A31.84,31.84,0,0,1,798,682.23c2.67-6.55,0-20.62-.74-26a25.83,25.83,0,0,0-2.91-9Z",
    transform: "translate(-82 -144)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M782.42,645.38l-14.8-2.66s-24.24,31.05-36.85,27.91-24.25,10.44-10.91,14.8c12.05,3.94,64.09,9.45,74,10.47a1.46,1.46,0,0,0,1.61-1.42,31.84,31.84,0,0,1,2.21-11.26c2.67-6.55,0-20.62-.74-26a25.83,25.83,0,0,0-2.91-9Z",
    transform: "translate(-82 -144)",
    fill: "#f3b5b7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 290,
    r: 32,
    opacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 290,
    r: 32,
    fill: "#f7c4a7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.5,465.5s38,13,38,40-21,70-22,105-56,30-56,30-8-118,0-127S1023.5,469.5,1019.5,465.5Z",
    transform: "translate(-82 -144)",
    fill: "#ae8eb4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.5,521.5s-14,62-47,51c0,0-17,25-5,36,0,0,29,7,48-12s33-26,36-49,5-55-5-52S1012.5,521.5,1012.5,521.5Z",
    transform: "translate(-82 -144)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.5,520.5s-14,62-47,51c0,0-17,25-5,36,0,0,29,7,48-12s33-26,36-49,5-55-5-52S1013.5,520.5,1013.5,520.5Z",
    transform: "translate(-82 -144)",
    fill: "#ae8eb4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M798.54,680c0,.09-.06.2-.09.28a29.28,29.28,0,0,0-1.57,5.29c.24-.78.52-1.58.84-2.38A14.52,14.52,0,0,0,798.54,680Z",
    transform: "translate(-82 -144)",
    fill: "#dddbe2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M720.59,682.51c-4.12-1.35-5.85-3.57-5.92-5.91-1.7,3.26-.63,6.92,5.19,8.82,12.05,3.94,64.1,9.45,74,10.47a1.46,1.46,0,0,0,1.61-1.43v0a1.47,1.47,0,0,0-1.31-1.49C783.3,691.81,732.48,686.39,720.59,682.51Z",
    transform: "translate(-82 -144)",
    fill: "#dddbe2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M631.78,652.43a12.32,12.32,0,0,1,1-2.12,9.75,9.75,0,0,0-2.35,3.88c-2.19,6.13,56.84,38.55,66.25,43.67a1.08,1.08,0,0,0,1.57-.71v0a1.08,1.08,0,0,0-.53-1.2C687.32,690.26,629.62,658.49,631.78,652.43Z",
    transform: "translate(-82 -144)",
    fill: "#dddbe2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M703.44,686.41c-.53.14-1.05.85-1.54,1.82l.16-.06c.44-.12,1.19-1,2.1-2.3A1.94,1.94,0,0,1,703.44,686.41Z",
    transform: "translate(-82 -144)",
    fill: "#dddbe2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M983.56,462.17c-2.82,6.22-3.41,13.23-5.48,19.75-4.11,12.93-14.42,23.63-26.77,27.76,10.39,4.14,22.65-.92,30.68-9.32s12.74-19.58,17.25-30.46c11.66,7.84,10.24,25.86,14.16,39.89a44.24,44.24,0,0,0,23.55,28.15,42.17,42.17,0,0,0,36.07-.73c-10.69-13-25.91-30.93-24.1-48.29,1.47-14.06-8.62-24.8-7.93-38.91,1-20-6.66-30.16-21-43-8.38-7.51,4.81-18.1-6-15-4.25,1.22-8.73-3.33-12.9-1.83-8.26,3-17.28,1.84-25.78,3.84C931.13,404.4,987.68,453.09,983.56,462.17Z",
    transform: "translate(-82 -144)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M984.56,461.17c-2.82,6.22-3.41,13.23-5.48,19.75-4.11,12.93-14.42,23.63-26.77,27.76,10.39,4.14,22.65-.92,30.68-9.32s12.74-19.58,17.25-30.46c11.66,7.84,10.24,25.86,14.16,39.89a44.24,44.24,0,0,0,23.55,28.15,42.17,42.17,0,0,0,36.07-.73c-10.69-13-24.91-27.93-23.1-45.29,1.47-14.06-.72-28.51,0-42.61,1-20-8.81-39.32-23.16-52.16-8.38-7.51-21.47-8.47-25.65-7-8.26,3-17.28,1.84-25.78,3.84C932.13,403.4,988.68,452.09,984.56,461.17Z",
    transform: "translate(-82 -144)",
    fill: "#57437c"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsiveness);
export default __webpack_public_path__ + "static/media/responsiveness.f13b27aab4a3001a15d5281dff99d062.svg";
export { ForwardRef as ReactComponent };